function OnSuccessSendSponsorship(data) {
    Foundation.libs.common.hidePreloader();

    if (!data.IsValid) {
        const validationMessage = $('#sponsorship-validation');
        if (!validationMessage.hasClass("hidden"))
            validationMessage.addClass("hidden")

        if (data.Errors) {
            const els = $('.form__item > b.-error > span[data-valmsg-for]');
            els.each((index, el) => {
                if (data.Errors[$(el).data("valmsg-for")] == undefined)
                    $(el).empty();
            })

            for (const [key, value] of Object.entries(data.Errors)) {
                const el = $("[data-valmsg-for=" + key + "]");
                el.empty();
                el.text(value);
            }
        }

        return;
    }

    const form = $("#sponsorship-form");
    const godsonsList = $('#godsons-list');
    const main = $("#sponsorship-main");
    console.log(main);
    if (data._Main)
        main.html(data._Main);

    // La requête renvoie le formulaire déjà rempli alors on vide le contenu des value=""
    if (data._Form)
        form.html(data._Form.replace(/value="[^"]*"/g, 'value=""').replace(/checked="[^"]*/g, ""));

    const textarea = form.find("textarea");
    textarea.val("");

    if (godsonsList)
        godsonsList.html(data._List);

    // Réattribution du value pour btn radio sinon ne rempli pas le model
    form.find("#radio-civility-mister")[0].setAttribute("value", "MR");
    form.find("#radio-civility-miss")[0].setAttribute("value", "MME");

    const validationMessage = $('#sponsorship-validation');
    validationMessage.removeClass();

    if (data.Status == 0) {
        // Client dupliqué ou non éligible
        validationMessage.addClass("-warning")
        validationMessage.text("Ce client n'est pas éligible au programme de parrainage.")
    } else if (data.Status == 10) {
        // Filleul créé
        validationMessage.addClass("-turcoise")
        validationMessage.text("Invitation envoyée par email à votre proche !")
    } else {
        // Erreur
        validationMessage.addClass("-error")
        validationMessage.text("Une erreur s'est produite, merci de ressayer ultérieurement.")
    }

    validationMessage.removeClass("hidden");

}

function toggleItems() {
    const wrapper = document.querySelector('.sponsorship__items');
    const btn = document.querySelector("#sponsorship-see-more > b")
    let isActive;

    wrapper.classList.toggle('-active');
    isActive = wrapper.classList.contains("-active");
    btn.innerText = isActive ? "Voir moins" : "Voir plus";
}

function OnSuccessUnsubscribeSponsorship(data) {
    Foundation.libs.common.hidePreloader();

    if (data.IsValid) {
        $("#unsubscribe-form").html(data._Form)
    }
}